const SidebarDocked = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.5 7A2.5 2.5 0 0 1 7 4.5h10A2.5 2.5 0 0 1 19.5 7v10a2.5 2.5 0 0 1-2.5 2.5H7A2.5 2.5 0 0 1 4.5 17zM7 5.5A1.5 1.5 0 0 0 5.5 7v10A1.5 1.5 0 0 0 7 18.5h2.5v-13zm3.5 0v13H17a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 17 5.5z"
      clipRule="evenodd"
    />
  </>
)
export default SidebarDocked
